import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useWorkData} from "../../hooks/useWorkData";
import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Pagination,
  Section,
  Table,
} from "@allxsmith/bestax-bulma";
import {
  getCostCentresData,
  getDataFresh,
  getDepartmentsData, getNominalCodesData,
  getPaymentTypesData, getTrackingOptionsData,
  getWorkData,
  getWorkTypeData
} from "../../state/selectors";
import {InvoiceRows, PORows} from "./TableRows";
import {createSetDataFreshAction, createSetWorkDataAction} from "../../actions/dataActions";
import axios from "axios";
import {FiguresSection} from "./FiguresSection";
import {useReactToPrint} from "react-to-print";
import PrintPO from "./PrintPO";
import PrintInvoice from "./PrintInvoice";
import FilterHeading from "./FilterHeading";
import Spinner from "react-spinner-material";
import useSelect from "../../hooks/useSelect";
import FilterBlankHeading from "./FilterBlankHeading";
import MultipleEditModalWorkshop from "./MultipleEditModalWorkshop";
import {
  updateBothInvoices,
  updateCustomerInvoice,
  updateHireCustomerInvoice,
  updateWorkshopInvoice
} from "./updateInvoice";
import MultipleEditModalCustomer from "./MultipleEditModalCustomer";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import useInput from "../../hooks/useInput";
import {formatXeroData, sendXeroData, validateBeforeApproval, expenseDueDate, compareVat} from "../../utils";
import {useWorkTypeData} from "../../hooks/useWorkTypeData";
import SearchBar from "../Utils/SearchBar";
import StateChangeModal from "./StateChangeModal";
import LoadingModal from "../Utils/LoadingModal";
import {usePaymentTypesData} from "../../hooks/usePaymentTypesData";
import {useNominalCodesData} from "../../hooks/useNominalCodesData";
import CreateCreditNoteModal from "../Credit Note/CreateCreditNoteModal";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import BlankDepartmentSelector from "../Utils/BlankDepartmentSelector";
import {useUtilData} from "../../hooks/useUtilData";
import {ToastContainer, toast} from "react-toastify";
import PaginationWrapper from "../Utils/PaginationWrapper";

function InvoicePO(props) {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [printDate, setPrintDate] = useState(new Date().toISOString());
  const [searchFresh, setSearchFresh] = useState(1);
  const [stateModalOpen, setStateModalOpen] = useState(false);
  const [selectedWork, setSelectedWork] = useState();
  const [filteredWork, setFilteredWork] = useState({results: []});
  const [loadingModal, setLoadingModal] = useState(false);
  const [multiStateChange, setMultiStateChange] = useState(false);
  const [creditModal, setCreditModal] = useState(false);
  const [selectedItemToCredit, setSelectedItem] = useState();

  const handlePrint =  useReactToPrint({contentRef: componentRef});

  const [filters, setFilters] = useState({});

  const [selected, setSelected] = useState({});

  useEffect(() => {
    getFilteredWork(props.view)
  }, [selectedWork]);

  const onCreditModalOpen = (data, partIndex) => {
    // Data should always be a work item
    let customer = data.customer;
    if(data.chargeable){
      customer = data.customer2;
    }
    let autoFill = {customer: customer};
    if(partIndex !== null){
      autoFill.part = data.parts[partIndex];
    }
    else{
      autoFill.work = data
    }
    setSelectedItem(autoFill);
    setCreditModal(true);
  }
  let [start, startInput, setStart] = useInput({
    type: "date",
    label: "Start Date",
    initialValue: undefined
  });

  let [end, endInput, setEnd] = useInput({
    type: "date",
    label: "End Date",
    initialValue: undefined
  });

  const [dueDateStart, dueDateStartInput, setDueDateStart] = useInput({
    type:"date",
    label:"Due Date Start",
  });

  const [dueDateEnd, dueDateEndInput, setDueDateEnd] = useInput({
    type:"date",
    label:"Due Date End"
  });

  let data = useSelector(getWorkData);



  const getCurrentState = (work) => {
    let currentState;
      if(work) {
          if (props.view === 'po') {
              currentState = work.po_approved ? "approved" : work.po_ready_to_approve ? "ready_to_approve" : "start"
          } else if (props.view === 'invoice') {
              currentState = work.invoice_approved ? "approved" : work.ready_to_approve ? "ready_to_approve" : "start"
          }
      }
      else {
          currentState = "start";
      }
      return currentState
  }
  const handleXeroDataSend = (inv, target) => {
    if(inv && inv.XeroDept){
      sendXeroData(inv, target).then(res => {
        toast.success("All data has been sent to xero", {position: "top-right"})
      }).catch(err => {
        toast.error("There was an error sending", {position: "top-right"})
      })
    }
  }
  const onStageChange = e => {
      let currentState = 'start';
      let condition;
      let sendData = false;
      let source;
      if(props.view === "po") {
        if (selectedWork) {
          currentState = getCurrentState(selectedWork);
          condition = filteredWork.results.length === selectedWork.no_free_of_charge_count
        } else if (selected && Object.entries(selected).length > 0) {
          currentState = getCurrentState(Object.entries(selected)[0][1]);
          condition = Object.entries(selected)[0][1].no_free_of_charge_count === filteredWork.results.length
        }
      }
      else if(props.view === "invoice"){
        if (selectedWork) {
          currentState = getCurrentState(selectedWork);
          condition = filteredWork.results.length === selectedWork.work_count
        } else if (selected && Object.entries(selected).length > 0) {
          currentState = getCurrentState(Object.entries(selected)[0][1]);
          condition = Object.entries(selected)[0][1].work_count === filteredWork.results.length
        }
      }
      let url;
      let validationResult = filteredWork.results.reduce((newVal, current)=> {
        let valid = validateBeforeApproval(current, props.view);
        return valid && newVal
      }, true);
      // check work_count against filteredWork count

      if(condition){
        if (validationResult || (currentState === "start")) {
          if (props.view === 'po') {
            if (currentState !== 'ready_to_approve') {
              url = 'api/work/readytoapprove'
              filteredWork.results.forEach((work) => work.po_ready_to_approve = true);
              sendData = false;
            }
            else if(currentState === "ready_to_approve"){
              url = 'api/work/approve';
              filteredWork.results.forEach((work) => {
                work.po_approved = true
                if(!(compareVat(work.supplier_nominal_code, work.labour_cost_vat))){
                  toast.warning("Selected Vat and Nominal Vat do not match", {position: "top-right"})
                  // MOVE WHEN SENDING INVOICES THROUGH AS APPROVED AS FLAG FOR DRAFT
                }
              });
              sendData = true;
            }
            let allSame = true;
            let posCount = 0;
            let negCount = 0;
            if(filteredWork.results && filteredWork.results.length > 1) {
              filteredWork.results.forEach(item =>  {
                if(Math.sign(item.labour_cost) === 1){
                  posCount++;
                }
                else if(Math.sign(item.labour_cost) === -1){
                  negCount++;
                }
              })
              // filteredWork.results.reduce((prev, next) => {
              //     // math.sign(0) returns 0, math.sign(900) returns 1
              //     // 0 is not treated as something with the same sign as a positive number
              //   allSame = (Math.sign(prev.labour_cost) === Math.sign(next.labour_cost)) || (Math.sign(next.labour_cost) === 0) || (Math.sign(prev.labour_cost) === 0);
              //
              //   return next
              // }, filteredWork.results[0]);
              if(posCount > 0 && negCount === 0){
                allSame = true
              }
              else if(negCount  > 0 && posCount === 0)
              {
                allSame = true
              }
              else{
                allSame = false
              }
            }
            if(allSame){
              if(filteredWork.results[0].labour_cost < 0){
                source = "WOP"
              }
              else{
                source = "WO"
              }
            }
            else{
              toast.error("Not all work items are of the same type (invoice or credit) No Changes have been made", {position: "top-right"})
              return
            }
          } else if (props.view === 'invoice') {
              if (currentState !== 'ready_to_approve') {
                url = 'api/work/readytoapprove';
                filteredWork.results.forEach((work) => work.ready_to_approve = true);
              } else if (currentState === 'ready_to_approve') {
                url = 'api/work/approve';
                sendData = true;
                source = "J";
                filteredWork.results.forEach((work) => work.invoice_approved = true);
              }
          }
          let conf = {
            data: filteredWork.results,
            method: "put",
            url: url
          }
          axios(conf).then((res) => {
            if(sendData && source){
                let invoice = formatXeroData(res.data, source); //Can Returns array with possible 2 invoices
                let target;
                console.log(invoice);
                if(Array.isArray(invoice)){
                  invoice.forEach(inv => {
                     if(!!inv && inv.XeroDept) {
                      if (source === "WOP") {
                        target = "PurchaseCreditNote"
                      } else if (source === "WO") {
                        target = "PurchaseInvoice"
                      } else if (source === "J") {
                        target = "SalesInvoice"
                      }
                      console.log(inv);
                      handleXeroDataSend(inv, target)
                    }
                  })
                }
                else {
                  if (invoice.XeroDept) {
                    if (source === "WOP") {
                      target = "PurchaseCreditNote"
                    } else if (source === "WO") {
                      target = "PurchaseInvoice"
                    } else if (source === "J") {
                      target = "SalesInvoice"
                    }
                    console.log(invoice);
                    if (source === "J") {
                      invoice.forEach(inv => {
                        handleXeroDataSend(inv, target);
                      })
                    } else {
                      handleXeroDataSend(invoice, target);
                    }
                  }
                }
            }
            dispatch(createSetDataFreshAction(dataFresh + 1));
            setStateModalOpen(false);
            setSelected({});
            setMultiStateChange(false);
          }).catch(err => {
            toast.error("There was an error aaaaaa", {postition: "top-right"});
            console.log(err);
          })
        } else {
          toast.warning("One or more work items are not valid for approval", {position: "top-right"});
        }
      }
      else{
        toast.warning("Not all work items are ready to be invoiced", {position: "top-right"})
      }
  }

  const dataFresh = useSelector(getDataFresh);
  let workTypes = useSelector(getWorkTypeData);
  let paymentTypes = useSelector(getPaymentTypesData);
  let nominalCodes = useSelector(getNominalCodesData);
  const trackingOptions = useSelector(getTrackingOptionsData);
  let departments = useSelector(getDepartmentsData);

  const workTypeObjects = workTypes ? workTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : [];

  const trackingOptionObjects = trackingOptions ? trackingOptions.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : [];

  const nominalCodeObjects = nominalCodes ? nominalCodes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : [];

  const paymentTypeObjects = paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : [];

  const departmentObjects = departments ? departments.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : [];

  const onPaymentTypeChange = (e, index) => {
    e.stopPropagation();
    let currentResults = [...data.results]
    let currentData = {...data, results: currentResults}
    let currentItem =  {...data.results[index]}
    currentItem.payment_type = paymentTypeObjects[e.target.value];
    currentData.results[index] = currentItem;
    dispatch(createSetWorkDataAction(currentData));
  };

  const onWorkTypeChange = (e, index) => {
    e.stopPropagation();
    let currentResults =  [...data.results]
    let currentData = {...data, results: currentResults};
    let currentItem =  {...data.results[index]}
    if(e.target.value !== 'BLANK') {
      currentItem.work_type = workTypeObjects[e.target.value];
    }
    else {
      currentItem.work_type= null;
    }
    currentData.results[index] = currentItem
    dispatch(createSetWorkDataAction(currentData));
  }

  const saveMultiple = (invoiceNumber, paymentDate, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate) => {
    const toSave = Object.values(selected).filter((item, pos, arr) => {
      return (
        arr
          .map(mapObj => mapObj.job.toString() + mapObj.chargeable.toString())
          .indexOf(item.job.toString() + item.chargeable.toString()) === pos
      );
    });

    let promises = [];

    let chargeableAndNonChargeable = [];

    toSave.forEach(work => {
      if (props.view === "po") {
        promises.push(
          updateWorkshopInvoice(
            props.endpoint,
            work.job,
            invoiceNumber,
            paymentDate,
            invoiceDate,
            null,
            trackingOption,
            nominalCode
          )
        );
      } else {
        // what if some of  the work items selected do not have a job buut some do
        // what if none of the selected work items have a job

        // If we are only updating one or the other *One or the other what?
        // this check asks if we are updating 1 or more different jobs
        // if we are updating more than 1 job it calls updateboth chargeable and not chargeable
        // what does this check filter out?
        if (toSave.filter(item => item.job === work.job).length === 1) {
          if (work.chargeable) {
            if(work.job) {
              promises.push(
                  updateHireCustomerInvoice(props.endpoint, work.job, invoiceNumber, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate)
              );
            }
            else{
              promises.push(
                  updateHireCustomerInvoice(props.endpoint, work.quote, invoiceNumber, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate, true)
              );
            }
          } else {
            if(work.job){
              promises.push(
                updateCustomerInvoice(props.endpoint, work.job, invoiceNumber, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate)
              );
            }
            else{
              promises.push(
                updateCustomerInvoice(props.endpoint, work.quote, invoiceNumber, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate, true)
              );
            }

          }
        } else {
          // If we need to update both we don't want to overwrite one, so store them
          chargeableAndNonChargeable.push(work);
        }
      }
    });

    // Condense the ones where we update both
    const toSaveBothValues = chargeableAndNonChargeable.filter(
      (item, pos, arr) => {
        return arr.map(mapObj => mapObj.job).indexOf(item.job) === pos;
      }
    );

    toSaveBothValues.forEach(item => {
      promises.push(
        updateBothInvoices(props.endpoint, item.job, invoiceNumber, trackingOption, nominalCode, partTrackingOption, partNominalCode, invoiceDate)
      );
    });

    return Promise.all(promises).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
      setSelected({});
    });
  };

  const onWorkSave = (work, setEditable, view, index) => {
    if(view === "po") {
      updateWorkshopInvoice(props.endpoint, work.job, work.job_workshop_invoice_number, (work.job_workshop_payment_date || null), (work.workshop_invoice_date || null), work.job_workshop_credit_number);
    }
    else if(view === "invoice"){
      if(work.job){
        if(work.chargeable){
          updateHireCustomerInvoice(props.endpoint, work.job, work.job_customer2_invoice_number);
        }
        else {
          updateCustomerInvoice(props.endpoint, work.job, work.job_customer_invoice_number);
        }
      }
      else{
        // it only has a quote
        if(work.chargeable){
          updateHireCustomerInvoice(props.endpoint, work.quote, work.job_customer2_invoice_number, null, null, null, null, null, true);
        }
        else {
          updateCustomerInvoice(props.endpoint, work.quote, work.job_customer_invoice_number, null, null, null, null, null, true);
        }
      }

    }
    let dataToSave = work;
    const conf = {
        data: dataToSave,
        method: "put",
        url: "api/work/update/"+ work.id
    }
    return axios(conf).then(res => {
        setEditable(false);
        dispatch(createSetDataFreshAction(dataFresh + 1));
    }).catch(err => {
        NotificationManager.error("There was an error")
    })
  }

  let mapping = {
    po: {
      title: "Workshop Expenses",
      contact: "supplier",
      contactFinder: "SP",
      figures: [
        {name: "Labour Total", prop: "total_labour"},
        {
          name: "Workshop Supplied Parts Total",
          prop: "total_workshop_supplied_part_cost"
        }
      ],
      headings: [
        {
          label: "Job No."
        },
        {
          label: "Registration",
          field: "job__vehicle",
          labelField: "job__vehicle__registration"
        },
        {
          label: "Workshop",
          field: "job__workshop",
          labelField: "job__workshop__display_name"
        },
        {
          label: "Customer",
          field: "customer",
          labelField: "customer_display_name"
        },
        {
          label: "Date",
          field: "job__finish_date",
          labelField: "job__finish_date",
          date: true
        },
        {label: "Invoice Date"},
        {label: "Description"},
        {label: "Comments"},
        {label: "Labour Cost"},
        {label: "VAT"},
        {
          label: "Work Type",
          field: "work_type",
          labelField: "work_type__name",
          className: "small-column"
        },
        {
          label: "Nominal Code"
        },
        {
          label: "Tracking Category"
        },
        {
          label: "Approval Received",
          field: "approval_received",
          labelField: "approval_received"
        },
        {
          label: "Warranty Claimed"
        },
        {
          label: "Payment Type",
          field: "payment_type",
          labelField: "payment_type__name",
          className: "small-column"
        },
        {
          label: "Workshop Invoice",
          plusBlanks: true,
          field: "job__workshop_invoice_number",
          labelField: "job__workshop_invoice_number",
        },
        {label: "Part Name" /*field: "parts__name"*/},
        {label: "Part Number" /*, field: "parts__number"*/},
        {label: "Supplier"},
        {label: "Part Cost"}
      ],
      approvalField: "po_approved",
      invoiceField: "job_workshop_invoice_number",
      rows: (value, index) => (
        <PORows
          workTypes={workTypes}
          onWorkTypeChange={e => onWorkTypeChange(e, index)}
          key={value.id}
          value={value}
          onApprove={openStateChangeModal}
          printCheck={printCheck}
          selected={Object.keys(selected).indexOf(value.id.toString()) !== -1}
          endpoint={props.endpoint}
          refresh={refreshData}
          setInvoiceNo={invoice_value =>
            updateWorkshopInvoiceValue(index, invoice_value)
          }
          setCreditNo={credit_value => updateWorkshopCreditValue(index, credit_value)}
          updateValue={newWork => updateValue(index, newWork)}
          approvedView={approved === 'approved'}
          paymentTypes={paymentTypes}
          onPaymentTypeChange={e => onPaymentTypeChange(e, index)}
          codeObjects={nominalCodeObjects}
          nominalCodes={nominalCodes}
          trackingOptions={trackingOptions}
          trackingOptionObjects={trackingOptionObjects}
        />
      ),
      print: (
        <PrintPO paymentDate={printDate} data={selected}/>
      ),
      multipleEditModal: (
        <MultipleEditModalWorkshop
          open={editModalOpen}
          setOpen={setEditModalOpen}
          selected={selected}
          saveSelected={saveMultiple}
          trackingOptions={trackingOptions}
          trackingObjects={trackingOptionObjects}
          nominalCodes={nominalCodes}
          codeObjects={nominalCodeObjects}
        />
      ),
      stageChangeModal: (
          <StateChangeModal
            view={"po"}
            open={stateModalOpen}
            setOpen={setStateModalOpen}
            selectedWork={selectedWork}
            filteredWork={filteredWork}
            setFilteredWork={setFilteredWork}
            getCurrentState={getCurrentState}
            multi={multiStateChange}
            setMulti={setMultiStateChange}
            setSelected={setSelected}
            onStageChange={onStageChange}
            workTypeObjects={workTypeObjects}
            workTypes={workTypes}
            onWorkSave={onWorkSave}
            codeObjects={nominalCodeObjects}
            nominalCodes={nominalCodes}
            endpoint={props.endpoint}
            trackingOptions={trackingOptions}
            trackingOptionObjects={trackingOptionObjects}
          />
      )
    },
    invoice: {
      title: "Workshop Invoicing",
      contact: "customer",
      contactFinder: "CC",
      headings: [
        {
          label: "Job #"
        },
        {
          label: "Registration",
          field: "job__vehicle",
          labelField: "job__vehicle__registration"
        },
        {
          label: "Workshop",
          field: "job__workshop",
          labelField: "job__workshop__display_name"
        },
        {
          label: "Customer",
          field: "customer",
          labelField: "customer_display_name"
        },
        {
          label: "Date",
          field: "job__finish_date",
          labelField: "job__finish_date",
          date: true
        },
        {label: "Description"},
        {label: "Invoice Date"},
        {label: "Customer Labour Charge"},
        {label: "Nominal Code"},
        {label: "Tracking Category"},
        {label: "Customer Amount Paid"},
        {label: "Workshop Invoice"},
        {
          label: "Invoice Number",
          plusBlanks: true,
          field: "job__invoice_number",
          labelField: "job__invoice_number"
        },
        {label: "Part Name"},
        {label: "Part Number"},
        {label: "Part Invoice No"},
        {label: "Supplier"},
        {label: "Customer Charge"},
        {label: "Source"},
        {label: "Comments"}
      ],
      figures: [
        {name: "Labour Total", prop: "total_customer_labour"},
        {name: "Parts Total", prop: "total_customer_part_cost"}
      ],
      approvalField: "invoice_approved",
      invoiceField: "job_customer_invoice_number",
      rows: (value, index) => {
        return (
          <InvoiceRows
            key={value.id}
            value={value}
            onStateChange={openStateChangeModal}
            printCheck={printCheck}
            selected={Object.keys(selected).indexOf(value.id.toString()) !== -1}
            endpoint={props.endpoint}
            refresh={refreshData}
            updateValue={newWork => updateValue(index, newWork)}
            setInvoiceNo={
              value.chargeable
                ? invoice_value =>
                  updateHireCustomerInvoiceValue(index, invoice_value)
                : invoice_value =>
                  updateCustomerInvoiceValue(index, invoice_value)
            }
            approvedView={approved === 'approved'}
            nominalCodes={nominalCodes}
            codeObjects={nominalCodeObjects}
            onCredit={onCreditModalOpen}
            trackingOptions={trackingOptions}
            trackingOptionObjects={trackingOptionObjects}
          />
        );
      },
      print: (
        <PrintInvoice
          paymentDate={printDate}
          data={selected}
        />
      ),
      multipleEditModal: (
        <MultipleEditModalCustomer
          open={editModalOpen}
          setOpen={setEditModalOpen}
          selected={selected}
          saveSelected={saveMultiple}
          trackingOptions={trackingOptions}
          trackingObjects={trackingOptionObjects}
          nominalCodes={nominalCodes}
          codeObject={nominalCodeObjects}
        />
      ),
      stageChangeModal: (
          <StateChangeModal
            view={"invoice"}
            open={stateModalOpen}
            setOpen={setStateModalOpen}
            selectedWork={selectedWork}
            filteredWork={filteredWork}
            setFilteredWork={setFilteredWork}
            getCurrentState={getCurrentState}
            multi={multiStateChange}
            setMulti={setMultiStateChange}
            setSelected={setSelected}
            onStageChange={onStageChange}
            workTypeObjects={workTypeObjects}
            workTypes={workTypes}
            onWorkSave={onWorkSave}
            nominalCodes={nominalCodes}
            codeObjects={nominalCodeObjects}
            endpoint={props.endpoint}
            trackingOptions={trackingOptions}
            trackingOptionObjects={trackingOptionObjects}
          />
      )
    }
  };

  const [page, setPage] = useState(1);
  let view_options = [
      {name: "Current", value: "all"},
      {name: "Ready To Invoice", value: "ready"},
      {name: "No Warranty Claim", value: "warrantyClaim"},
      {name: "Approval Needed", value:"apNeeded"},
      {name: "Approved", value: "approved"}
  ]
  if(props.view === 'po'){
    view_options[1] = {name: "Ready To Approve", value:"ready"}
  }
  if(props.view === 'invoice'){
    view_options.splice(2,2);
  }
  const [approved, approvedInput] = useSelect({
    label: "View",
    options: view_options,
    initialValue: "all",
    testId: "invoice-view",
    callback: () => {
      setPage(1);
    }
  });
  let [selectedDepartment, setSelectedDepartment] = useState(-1);

  let params = {
    page,
    view: props.view,
    all: true
  };
  if (start) {
    params.start = start;
  }
  if (end) {
    params.end = end;
  }
  if (approved === "approved") {
    params.approved = true;
  }
  if (approved === "ready"){
    params.ready = true;
  }
  if (approved === "apNeeded"){
    params.apNeeded = true;
  }
  if (approved === "warrantyClaim"){
    params.warrantyClaim = true;
  }
  if (selectedDepartment) {
    params.department = selectedDepartment;
  }

  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }


  const complete = useWorkData(params, dataFresh)



  const onDepartmentSelection = (e) => {
    setSelectedDepartment(e.target.value);
  }


  const updateHireCustomerInvoiceValue = (index, invoiceNumber) => {
    let newResults =  [...data.results];
    let currentData = {...data, results: newResults};
    let newData = {...currentData.results[index]}
    newData.job_customer2_invoice_number = invoiceNumber;
    currentData.results[index] = newData
    dispatch(createSetWorkDataAction(currentData));
  };

  const updateCustomerInvoiceValue = (index, invoiceNumber) => {
    let newResults =  [...data.results];
    let currentData = {...data, results: newResults};
    let newData = {...currentData.results[index]}
    newData.job_customer_invoice_number = invoiceNumber;
    currentData.results[index] = newData
    dispatch(createSetWorkDataAction(currentData));
  };

  const updateWorkshopInvoiceValue = (index, invoiceNumber) => {
    let newResults = [...data.results];
    let currentData = {...data, results: newResults};
    currentData.results[index].job_workshop_invoice_number = invoiceNumber;
    dispatch(createSetWorkDataAction(currentData));
  };

  const updateWorkshopCreditValue = (index, creditNumber) => {
    let newResults = [...data.results];
    let currentData = {...data,  results: newResults};
    currentData.results[index].job_workshop_credit_number = creditNumber;
    dispatch(createSetWorkDataAction(currentData));
  };

  const updateValue = (index, newWork) => {
    let newResults =  [...data.results];
    let currentData = {...data, results: newResults};
    currentData.results[index] = newWork;
    dispatch(createSetWorkDataAction(currentData));
  };


  const handleReadyToApprove = (work, multi) => {
      const endpoint = props.endpoint + "work/readytoapprove";
      let data = multi ? work : [work]; // Causes array of arrays
      const conf = {
        method: "put",
        data: data,
        url: endpoint
      };

      axios(conf).then(() => {
        refreshData();
      }).catch(err => {
        toast.error("There was an error", {position: "top-right"});
      })
  }

  const getMultiFilteredWork = (view) => {
    if(selected && Object.entries(selected).length > 0){
      let currentState = getCurrentState(Object.entries(selected)[0][1]); //All selected items should share a state
      let additionalFilter;
      let jobs = [];
      let promise = [];
      if(currentState === "ready_to_approve"){
        additionalFilter= "ready=true"
      }

      Object.entries(selected).forEach(work => {
        if(!jobs.includes(work[1].job)){
          jobs.push(work[1].job)
        }
      });
      jobs.forEach(job => {
        let conf = {
          url: props.endpoint + `work?view=${view}&job=${job}&${additionalFilter}`,
          method: 'get',
          cache: false
        }
        setLoadingModal(true);

        promise.push(axios(conf));

      });
      Promise.all(promise).then(res => {
        setFilteredWork({results: res.reduce((newVal, current) => {
            return newVal.concat(current.data.results);
          }, [])
        });
        setLoadingModal(false);
        })
    }
  }

  const onSelectStateChange = e => {
    setMultiStateChange(true);
    setStateModalOpen(true);
    getMultiFilteredWork(props.view);
  };


  const getFilteredWork = (view) => {
    if(selectedWork) {
      let currentState = getCurrentState(selectedWork);
      let additionalFilter = "";
      if(currentState === "ready_to_approve"){
        additionalFilter= "&ready=true"
      }
      if(selectedWork.labour_cost < 0){
        additionalFilter += "&negative=true"
      }
      else{
        additionalFilter += "&negative=false"
      }

      if(view === "invoice") {
        if (selectedWork.chargeable) {
          if (selectedWork.customer2_id) {
            additionalFilter += "&customer=" + selectedWork.customer2_id;
          }
        } else if (!selectedWork.chargeable) {
          if (selectedWork.customer_id) {
            additionalFilter += "&customer=" + selectedWork.customer_id;
          }
        }
        if(selectedWork.quote){
          additionalFilter += "&quote=" + selectedWork.quote
        }
        else{
          additionalFilter += "&job=" + selectedWork.job
        }
      }
      else if(view === "po"){
        additionalFilter += "&job=" + selectedWork.job
      }

      let conf = {
        url: props.endpoint + `work?view=${view}${additionalFilter}&ignore=false&page_size=1000`,
        method: 'get'
      }
      return axios(conf).then(res => {
        setFilteredWork(res.data);
      }).catch(err => {
        toast.error("There was an error", {position: "top-right"})
      })
    }
  }

  const openStateChangeModal = (work) => {
    setSelectedWork(work);
    setStateModalOpen(true);
  }



  const toggleSelectVisible = () => {
    let newSelected = {...selected};
    let selectedKeys = Object.keys(newSelected);
    const notPresent = data.results.find(
      workItem => selectedKeys.indexOf(workItem.id.toString()) === -1
    );

    if (notPresent) {
      data.results.forEach(item => {
        newSelected[item.id.toString()] = item;
      });
    } else {
      data.results.forEach(item => {
        delete newSelected[item.id.toString()];
      });
    }
    setSelected(newSelected);
  };

  const dueDateFilter = (work) => {
    let dueDate = expenseDueDate(work, "workshop_invoice_date", "workshop_details");
    let filterStart = new Date(dueDateStart);
    let filterEnd = new Date(dueDateEnd);
    if(dueDate >= filterStart && dueDate <= filterEnd){
      return true
    }
    return false
  }

  const selectDueDateFilter = () => {
    if(dueDateStart && dueDateEnd) {
      let newSelected = { ...selected };
      let filteredItems = data.results.filter((part) => dueDateFilter(part));
      filteredItems.forEach(item => {
        newSelected[item.id.toString()] = item;
      });

      setSelected(newSelected);
    } else {
      toast.warning("Please enter due date start and end", {position: "top-right"})
    }
  }

  const refreshData = () => {
    dispatch(createSetDataFreshAction(dataFresh + 1));
    setSelected({});
  };

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const printCheck = item => {
    let newPrintSelection = {...selected};
    if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
      newPrintSelection[item.id.toString()] = item;
    } else {
      delete newPrintSelection[item.id.toString()];
    }
    setSelected(newPrintSelection);
  };

  if (!complete || !data || !props.loaded){
      return (
      <div className="spinner-centre">
        <Spinner
          className="spinner-centre"
          radius={120}
          color={"#3273dc"}
          stroke={5}
        />
      </div>
    );
  }

  document.title = mapping[props.view].title;

  // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <div>
      <br/>
      <br/>
      <Box>
        <h1 className="title">{(props.loaded && !!departmentObjects[selectedDepartment]) ? mapping[props.view].title + " - " + departmentObjects[selectedDepartment].name : mapping[props.view].title}</h1>
        <Columns isMultiline>
          {approvedInput}
          <Column>
            <BlankDepartmentSelector
              departments={departments}
              onDepartmentChange={onDepartmentSelection}
              selectedDepartment={selectedDepartment}
            />
          </Column>
          {startInput}
          {endInput}
          <Column size={5}>
            <label className="label">Search</label>
            <SearchBar
              handleSearch={handleSearch}
              clear={clear}
              setSearchText={setSearchText}
              searchText={searchText}
            />
          </Column>
          {dueDateStartInput}
          {dueDateEndInput}
          <Column>
            <label className="label">button</label>
            <Button
              color={"success"}
              onClick={selectDueDateFilter}
            >
              Select Filtered Work Items
            </Button>
          </Column>
        </Columns>
      </Box>
      <div style={{display: "none"}}>
        <div ref={componentRef}>
          {mapping[props.view].print}
        </div>
      </div>
      <FiguresSection data={data} figures={mapping[props.view].figures}/>
      <Box>
        <Table className="is-hoverable">
          <thead>
          <tr className="small-row-black">
            {mapping[props.view].headings.map(heading => {
              if (!heading.field) {
                return <th className={heading.className} key={heading.label}>{heading.label}</th>;
              }
              if (heading.blank) {
                return (
                  <FilterBlankHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    className={heading.className}
                  />
                );
              }
              return (
                <FilterHeading
                  key={heading.label}
                  heading={heading}
                  setFilters={f => {
                    setPage(1);
                    setFilters(f);
                  }}
                  filters={filters}
                  options={data.filter_list[heading.field]}
                  className={heading.className}
                />
              );
            })}
            {approved === 'approved' && <th>Approver</th>}
            <th>
              <Button
                onClick={toggleSelectVisible}
                color={
                  data.results.find(
                    workItem =>
                      Object.keys(selected).indexOf(
                        workItem.id.toString()
                      ) === -1
                  )
                    ? ""
                    : "danger"
                }
              >
                {data.results.find(
                  workItem =>
                    Object.keys(selected).indexOf(workItem.id.toString()) ===
                    -1
                ) ? (
                  <div>
                    O
                    <span> Visible</span>
                  </div>
                ) : (
                  <div>
                    X
                    <span> Visible</span>
                  </div>
                )}
              </Button>
            </th>
            {!!Object.entries(selected).length && (
              <th>
                <Button onClick={() => setSelected({})} color="danger">
                  X
                </Button>
              </th>
            )}
          </tr>
          </thead>
          <tbody>{data.results.map(mapping[props.view].rows)}</tbody>
        </Table>
        <div className={"second-delete"}>
          <Button
            onClick={toggleSelectVisible}
            color={
              data.results.find(
                workItem =>
                  Object.keys(selected).indexOf(
                    workItem.id.toString()
                  ) === -1
              ) ? "" : "danger"
            }
            className={"second-delete-button"}
          >
            {data.results.find(
              workItem =>
                Object.keys(selected).indexOf(workItem.id.toString()) ===
                -1
            ) ? (
              <div>
                O
                <span> Visible</span>
              </div>
            ) : (
              <div>
                X
                <span> Visible</span>
              </div>
            )
            }
          </Button>
        </div>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        />
      </Box>
      <Box>
        <Columns isMultiline>
          <Column>
            <Button
              onClick={() => setEditModalOpen(true)}
              disabled={!Object.entries(selected).length}
              color={Object.entries(selected).length ? "primary" : ""}
              isFullWidth
            >
              Edit Selected
            </Button>
          </Column>
          <Column>
            <Button
              onClick={() => setModalOpen(true)}
              color={Object.entries(selected).length ? "warning" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Print Selected
            </Button>
          </Column>
          {(approved === "all" && props.view === "invoice") && false &&(
            <Column>
              <Button
                onClick={() => {
                  onSelectStateChange();
                }}
                color={Object.entries(selected).length ? "success" : ""}
                disabled={!Object.entries(selected).length}
                isFullWidth
              >
                Ready To Invoice Selected
              </Button>
            </Column>
          )}
          {(approved === "ready" || props.view === 'po') && false && (
            <Column>
              <Button
                onClick={() => {
                  onSelectStateChange()
                }}
                color={Object.entries(selected).length ? "success" : ""}
                disabled={!Object.entries(selected).length}
                isFullWidth
              >
                Approve Selected
              </Button>
            </Column>
          )}
        </Columns>
      </Box>
      <Modal closeOnBlur active={modalOpen} onClose={() => setModalOpen(false)}>
        <Modal.Content>
          <Section style={{backgroundColor: "white"}}>
            {props.view === "invoice" && (
              <Field>
                <Control>
                  <label className="label">Select an Invoice Date</label>
                  <Input
                    type="date"
                    value={printDate || ""}
                    onChange={e => setPrintDate(e.target.value)}
                  />
                </Control>
              </Field>
            )}
            <Field>
              <p>
                You have selected {Object.keys(selected).length} out of total of{" "}
                {data.count} items for printing
              </p>
            </Field>
            <Columns>
              <Column>
                <Button
                  color={Object.entries(selected).length ? "success" : ""}
                  onClick={handlePrint}
                >
                  Print Selected
                </Button>
              </Column>
              <Column>
                <Button
                  color={"info"}
                  onClick={()=> setModalOpen(false)}
                >
                  Cancel
                </Button>
              </Column>
            </Columns>
          </Section>
        </Modal.Content>
      </Modal>
      {mapping[props.view].multipleEditModal}
      {mapping[props.view].stageChangeModal}
      <LoadingModal
        open={loadingModal}
        setOpen={setLoadingModal}
      />
      {selectedItemToCredit &&
        <CreateCreditNoteModal
          autoFill={selectedItemToCredit}
          open={creditModal}
          setOpen={setCreditModal}
          endpoint={props.endpoint}
          dataFresh={dataFresh}
        />
      }
    </div>
  );
}

export default InvoicePO;
